import styles from './ChevronUp.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function ChevronUp({className}) {
  const classNameArray = className?.split(' ') || [];
	return (
		<svg width="100%" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['chevron-up-icon', ...classNameArray])} aria-hidden="true">
			<path d="m15 8.25-6.5-6.5L2 8.25" stroke="#202020" strokeWidth="2.34" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
